class FluxTabs extends HTMLElement {
  static CLASSES = {
    bgWhite: 'bg-white',
    bgThemeBlack: 'bg-theme-black',
    bgThemeGrey300: 'bg-theme-grey-300',
    visible: 'visible',
  }

  static SELECTORS = {
    tabs: '[data-tab]',
    scroll: '[data-scroll]',
    bullets: '[data-bullet]',
    desktop: "[data-desktop='true']",
    mobile: "[data-mobile='true']",
    content: '[data-content]',
  }

  constructor() {
    super()

    this.tabs = this.querySelectorAll(FluxTabs.SELECTORS.tabs)
    this.bullets = this.querySelectorAll(FluxTabs.SELECTORS.bullets)
    this.scrollContent = this.querySelector(FluxTabs.SELECTORS.scroll)
    this.currentIndex = 0

    this.isDragging = false
    this.startX = 0
    this.scrollLeft = 0

    this._items = Array.from(
      this.querySelector(FluxTabs.SELECTORS.scroll).children
    )
  }

  connectedCallback() {
    this.bindEvents()
  }

  wrappedIndex(e) {
    return (e %= this._items.length) < 0 ? this._items.length + e : e
  }

  handleClick(event) {
    event.preventDefault()

    const { target } = event

    const current = target.dataset.tab

    this.animateToItem(Number(current))

    this.updateTabs()

    this.animateContent()
  }

  updateBullets() {
    this.bullets.forEach((bullet, index) => {
      if (index === this.currentIndex) {
        bullet.classList.add(FluxTabs.CLASSES.bgThemeBlack)
        bullet.classList.remove(FluxTabs.CLASSES.bgThemeGrey300)
      } else {
        bullet.classList.remove(FluxTabs.CLASSES.bgThemeBlack)
        bullet.classList.add(FluxTabs.CLASSES.bgThemeGrey300)
      }
    })
  }

  updateTabs() {
    this.tabs.forEach((tab, index) => {
      if (index === this.currentIndex) {
        tab.classList.add(FluxTabs.CLASSES.bgWhite)
      } else {
        tab.classList.remove(FluxTabs.CLASSES.bgWhite)
      }
    })
  }

  handleClickBullet(event) {
    event.preventDefault()
    const { target } = event

    const current = target.dataset.bullet

    this.animateToItem(Number(current))

    this.updateBullets()
  }

  animateContent() {
    const target = this._items[this.wrappedIndex(this.currentIndex)]

    this._items.forEach((item) => {
      item
        .querySelectorAll(FluxTabs.SELECTORS.content)
        .forEach((content) =>
          content.classList.remove(FluxTabs.CLASSES.visible)
        )
    })

    const currentContent = target.querySelector(FluxTabs.SELECTORS.content)
    currentContent.classList.add(FluxTabs.CLASSES.visible)
  }

  animateToItem(index) {
    if (
      this.currentIndex === index ||
      this.currentIndex === this.wrappedIndex(index)
    ) {
      return
    }

    const targetElement = this._items[this.wrappedIndex(index)]
    const targetPosition =
      targetElement.offsetLeft +
      targetElement.offsetWidth / 2 -
      this.scrollContent.clientWidth / 2

    this.scrollContent.scrollTo({
      left: targetPosition,
      behavior: 'smooth',
    })

    this.currentIndex = index

    this.handleVideo(targetElement)
  }

  handleVideo(target) {
    const isMobile = window.innerWidth <= 990

    this._items.forEach((item) => {
      item.querySelectorAll('video').forEach((video) => video.pause())
    })

    const videoSelector = isMobile
      ? FluxTabs.SELECTORS.mobile
      : FluxTabs.SELECTORS.desktop
    const videoToPlay = target.querySelector(videoSelector)

    if (!videoToPlay) return

    videoToPlay.play()
  }

  handleScrollX(event) {
    const scrollContent = event.target
    const scrollLeft = scrollContent.scrollLeft
    const slideWidth = scrollContent.clientWidth

    let closestIndex = 0
    let closestDistance = Infinity

    this._items.forEach((el, index) => {
      const elCenter = el.getBoundingClientRect().left + el.offsetWidth / 2
      const mediaLeft = scrollContent.getBoundingClientRect().left

      const distance = Math.abs(elCenter - mediaLeft - slideWidth / 2)

      if (distance < closestDistance) {
        closestDistance = distance
        closestIndex = index
      }
    })

    this.currentIndex = closestIndex

    this.updateBullets()

    this.updateTabs()

    this.animateContent()

    const target = this.querySelector(`[data-index="${this.currentIndex}"]`)
    this.handleVideo(target)
  }

  bindEvents() {
    this.tabs.forEach((tab) =>
      tab.addEventListener('click', this.handleClick.bind(this))
    )
    this.bullets.forEach((bullet) =>
      bullet.addEventListener('click', this.handleClickBullet.bind(this))
    )

    this.scrollContent.addEventListener(
      'scroll',
      this.handleScrollX.bind(this),
      { passive: true }
    )
  }
}

customElements.get('flux-tabs') || customElements.define('flux-tabs', FluxTabs)
